import React, { useEffect, useState } from "react";
import DTOAirTicketViewModal from "./DTOAirTicketViewModal";
import AirTicketViewModalPresenter from "./AirTicketViewModalPresenter";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  airticketViewData?: any;
}

const AirTicketViewModalContoller = ({
  isModalOpen,
  closeModal,
  airticketViewData,
}: ModalInterface) => {
  const { t } = useTranslation();

  return (
    <div>
      <DTOAirTicketViewModal />

      <AirTicketViewModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        airticketViewData={airticketViewData}
        trans={t}
      />
    </div>
  );
};

export default AirTicketViewModalContoller;
